// Tout le JavaScript du theme. Sans script, le site reste utilisable :
// les formulaires postent normalement et les liens menent aux produits.

// ---------- Menu mobile ----------
const menu = document.querySelector('[data-menu]');
if (menu) {
  const openBtn = document.querySelector('[data-open-menu]');
  const setOpen = (open) => {
    open ? menu.showModal() : menu.close();
    openBtn?.setAttribute('aria-expanded', String(open));
  };
  openBtn?.addEventListener('click', () => setOpen(true));
  menu.querySelector('[data-close-menu]')?.addEventListener('click', () => setOpen(false));
  menu.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
}

// ---------- Pastilles : survol = photo de l'autre couleur ----------
// Les photos sont prechargees des que le produit entre a l'ecran : plus de latence au survol.
const preloaded = new Set();
const preload = (url) => {
  if (!url || preloaded.has(url)) return;
  preloaded.add(url);
  new Image().src = url;
};

const seen = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('[data-swap-src]').forEach((s) => preload(s.dataset.swapSrc));
    seen.unobserve(entry.target);
  });
}, { rootMargin: '200px' });

const bound = new WeakSet();
const initSwatches = (scope = document) => scope.querySelectorAll('[data-swap-root]').forEach((root) => {
  if (bound.has(root)) return;
  bound.add(root);
  const img = root.querySelector('img');
  const swatches = root.querySelector('.swatches');
  if (!img || !swatches) return;
  seen.observe(root);

  // Sur la fiche, toutes les photos de la galerie changent ; sur une carte, la premiere seulement.
  const gallery = root.querySelector('.pdp__gallery');
  const targets = gallery ? [...gallery.querySelectorAll('img')] : [img];
  const originals = targets.map((t) => ({ src: t.src, srcset: t.srcset }));

  const show = (swatch) => {
    const list = (swatch.dataset.swapList || swatch.dataset.swapSrc).split('|');
    root.classList.add('is-swatching');
    targets.forEach((t, i) => {
      if (!list[i]) return;
      t.srcset = '';
      t.src = list[i];
    });
  };
  const restore = () => {
    root.classList.remove('is-swatching');
    targets.forEach((t, i) => { t.src = originals[i].src; t.srcset = originals[i].srcset; });
  };

  swatches.querySelectorAll('[data-swap-src]').forEach((swatch) => {
    (swatch.dataset.swapList || '').split('|').forEach(preload);
    swatch.addEventListener('mouseenter', () => show(swatch));
    swatch.addEventListener('mouseleave', restore);
    swatch.addEventListener('focus', () => show(swatch));
    swatch.addEventListener('blur', restore);
  });
});
initSwatches();

// ---------- Declinaisons de couleur : jamais cote a cote dans une liste ----------
// Une piece de la meme famille est repoussee de 2 places (ecart de 3) ; en fin de liste, avancee.
const spreadFamilies = (scope = document) => {
  scope.querySelectorAll('.grid-products, [data-rail-track]').forEach((grid) => {
    if (grid.hasAttribute('data-keep-order')) return;
    const fam = (el) => el.dataset?.family || el.querySelector?.('[data-family]')?.dataset.family || '';
    for (let pass = 0; pass < 20; pass += 1) {
      const list = [...grid.children];
      const i = list.findIndex((el, k) => fam(el) && list.slice(Math.max(0, k - 2), k).some((p) => fam(p) === fam(el)));
      if (i < 0) break;
      const node = list[i];
      if (i + 3 <= list.length) grid.insertBefore(node, list[i + 3] || null);
      else grid.insertBefore(node, list[Math.max(0, i - 4)]);
    }
  });
};
spreadFamilies();
document.addEventListener('coll:updated', () => { initSwatches(); spreadFamilies(); });

// ---------- Ajout rapide depuis la carte ----------
const root = window.Shopify?.routes?.root || '/';
const bump = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((el) => { if (count != null) el.textContent = count; });
  const icon = document.querySelector('[data-cart-count]')?.closest('a');
  icon?.classList.remove('is-bumped');
  void icon?.offsetWidth; // relance l'animation a chaque ajout
  icon?.classList.add('is-bumped');
};
// Ajoute puis ouvre le panier lateral tout de suite (cart-drawer.js) ; sinon ancien chemin.
const addToCart = async (items) => {
  if (window.charmsCart) {
    const res = await window.charmsCart.add(items);
    bump(res?.item_count ?? null);
    return;
  }
  const res = await fetch(root + 'cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });
  if (!res.ok) throw new Error(String(res.status));
  const cart = await (await fetch(root + 'cart.js')).json();
  bump(cart.item_count);
  document.dispatchEvent(new CustomEvent('cart:added'));
};
document.addEventListener('submit', async (e) => {
  const form = e.target.closest?.('[data-quick-add]');
  if (!form) return;
  e.preventDefault();
  form.classList.add('is-adding');
  try {
    await addToCart([{ id: Number(new FormData(form).get('id')), quantity: 1 }]);
  } catch {
    form.submit(); // en cas d'echec, on passe par le formulaire classique
  } finally {
    setTimeout(() => form.classList.remove('is-adding'), 400);
  }
});

// ---------- Piece phare : les photos defilent au survol ----------
document.querySelectorAll('[data-cycle]').forEach((el) => {
  const imgs = [...el.querySelectorAll('img')];
  if (imgs.length < 2) return;
  let i = 0;
  let timer;
  const step = () => {
    imgs[i].classList.remove('is-on');
    i = (i + 1) % imgs.length;
    imgs[i].classList.add('is-on');
  };
  el.addEventListener('mouseenter', () => { step(); timer = setInterval(step, 1100); });
  el.addEventListener('mouseleave', () => {
    clearInterval(timer);
    imgs[i].classList.remove('is-on');
    i = 0;
    imgs[0].classList.add('is-on');
  });
});

// ---------- Fond des bandeaux = fond reel de la photo ----------
// Certaines photos sont en #F8F8F8 au lieu de #F6F6F6 : on lit le coin de l'image
// (le CDN Shopify autorise la lecture) et on l'applique au bloc, pour un raccord invisible.
document.querySelectorAll('[data-bg-sample]').forEach((block) => {
  const src = block.querySelector('img')?.currentSrc || block.querySelector('img')?.src;
  if (!src) return;
  const probe = new Image();
  probe.crossOrigin = 'anonymous';
  probe.onload = () => {
    try {
      const c = document.createElement('canvas');
      c.width = c.height = 1;
      const ctx = c.getContext('2d');
      ctx.drawImage(probe, 1, 1, 1, 1, 0, 0, 1, 1); // pixel du coin haut-gauche
      const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data;
      if (Math.min(r, g, b) < 225) return; // photo sombre ou coloree : on garde le fond du theme
      block.style.setProperty('--craft-bg', `rgb(${r}, ${g}, ${b})`);
      if (!block.classList.contains('craft')) block.style.background = `rgb(${r}, ${g}, ${b})`;
    } catch { /* lecture refusee : on garde le fond du theme */ }
  };
  probe.src = src.replace(/width=\d+/, 'width=40');
});

// ---------- Colonne produit : defile avec la page, puis s'arrete bas visible ----------
const stick = document.querySelector('[data-scroll-stick]');
if (stick) {
  const place = () => {
    const header = document.querySelector('.header')?.offsetHeight || 50;
    const top = Math.min(header + 24, window.innerHeight - stick.offsetHeight - 24);
    stick.style.setProperty('--stick-top', `${top}px`);
  };
  place();
  window.addEventListener('resize', place);
  stick.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', place));
}

// ---------- Carrousel photo sur telephone : barre de progression fine ----------
document.querySelectorAll('[data-carousel]').forEach((track) => {
  const bar = track.parentElement.querySelector('[data-carousel-progress]');
  if (!bar) return;
  const total = track.children.length;
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const ratio = max > 0 ? track.scrollLeft / max : 0;
    bar.style.setProperty('--p', `${ratio * (total - 1) * 100}%`);
  };
  track.addEventListener('scroll', update, { passive: true });
  update();
});

// ---------- Barre d'achat : apparait quand le bouton principal sort de l'ecran ----------
const stickyAtc = document.querySelector('[data-sticky-atc]');
const mainAtc = document.querySelector('[data-main-atc]');
if (stickyAtc && mainAtc) {
  const footer = document.querySelector('.footer');
  // Partie "L'ensemble" a l'ecran : son propre bouton suffit, la barre s'efface (pas de doublon).
  const zones = document.querySelectorAll('[data-set-zone]');
  const sync = () => {
    const vh = document.documentElement.clientHeight;
    // Visible des que le bouton principal n'est pas a l'ecran (sur telephone il est sous les photos).
    const r = mainAtc.getBoundingClientRect();
    const outOfView = r.bottom < 0 || r.top > vh;
    const atFooter = footer ? footer.getBoundingClientRect().top < vh : false;
    const inSet = [...zones].some((z) => { const b = z.getBoundingClientRect(); return b.top < vh && b.bottom > 0; });
    stickyAtc.hidden = !(outOfView && !atFooter && !inSet);
  };
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
}

// ---------- En-tete : texte blanc sur la photo sombre du haut, noir ailleurs ----------
const header = document.querySelector('[data-header]');
const darkZone = document.querySelector('[data-header-dark]');
if (header && darkZone) {
  const sync = () => header.classList.toggle('is-on-dark', darkZone.getBoundingClientRect().bottom > header.offsetHeight);
  sync();
  window.addEventListener('scroll', sync, { passive: true });
}

// ---------- Photos produit : fenetre photo, clic pour zoomer ----------
const zoom = document.querySelector('[data-zoom-dialog]');
if (zoom) {
  const shots = [...zoom.querySelectorAll('.zoom__track img')];
  let cur = 0;
  const show = (i) => {
    cur = (i + shots.length) % shots.length;
    zoom.classList.remove('is-zoomed');
    shots.forEach((img, k) => {
      img.classList.toggle('is-active', k === cur);
      if (Math.abs(k - cur) <= 1) img.loading = 'eager';
    });
  };
  const follow = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
  };
  shots.forEach((img) => {
    img.addEventListener('click', (e) => { follow(e); zoom.classList.toggle('is-zoomed'); });
    img.addEventListener('mousemove', (e) => { if (zoom.classList.contains('is-zoomed')) follow(e); });
  });
  document.querySelectorAll('[data-zoom]').forEach((btn) => {
    btn.addEventListener('click', () => { show(Number(btn.dataset.zoom)); zoom.showModal(); });
  });
  zoom.querySelector('[data-zoom-prev]')?.addEventListener('click', () => show(cur - 1));
  zoom.querySelector('[data-zoom-next]')?.addEventListener('click', () => show(cur + 1));
  zoom.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoom.close());
  zoom.addEventListener('click', (e) => { if (e.target === zoom) zoom.close(); });
  zoom.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') show(cur - 1);
    if (e.key === 'ArrowRight') show(cur + 1);
  });
  let startX = null;
  zoom.addEventListener('touchstart', (e) => { startX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
  zoom.addEventListener('touchend', (e) => {
    if (startX == null || zoom.classList.contains('is-zoomed')) return;
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
  });
}

// ---------- Pop-up newsletter : au plus une fois par 24 h, jamais apres inscription ----------
const promo = document.querySelector('[data-promo]');
if (promo) {
  const KEY = 'charms-promo-vu';
  const DONE = 'charms-inscrit';
  const DAY = 24 * 60 * 60 * 1000;
  // Une fois vue : pas avant 24 h (une seule fois par visite) ; apres inscription : plus jamais.
  const seen = (() => {
    try { return localStorage.getItem(DONE) || Date.now() - Number(localStorage.getItem(KEY) || 0) < DAY; } catch { return true; }
  })();
  const open = () => {
    if (promo.open) return;
    promo.showModal();
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* navigation privee */ }
  };
  if (promo.dataset.success === 'true') {
    try { localStorage.setItem(DONE, '1'); } catch { /* navigation privee */ }
    promo.showModal();
  }
  else if (!seen && !location.pathname.includes('/cart')) {
    // Une seule fois, 15 s apres le debut de la visite (avec ou sans defilement) (le temps continue de compter d'une page a l'autre).
    let debut = Date.now();
    try { debut = Number(sessionStorage.getItem('charms-visite-debut')) || debut; sessionStorage.setItem('charms-visite-debut', String(debut)); } catch { /* navigation privee */ }
    setTimeout(open, Math.max(0, 15000 - (Date.now() - debut)));
  }
  document.querySelectorAll('[data-open-promo]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); if (!promo.open) promo.showModal(); }));
  promo.querySelectorAll('[data-promo-close]').forEach((b) => b.addEventListener('click', () => promo.close()));
  promo.addEventListener('click', (e) => { if (e.target === promo) promo.close(); });
}

// ---------- Carrousels : fleches, avance d'un produit, masquees aux extremites ----------
document.querySelectorAll('[data-rail]').forEach((rail) => {
  const track = rail.querySelector('[data-rail-track]');
  const prev = rail.querySelector('[data-rail-prev]');
  const next = rail.querySelector('[data-rail-next]');
  if (!track || !prev || !next) return;
  const step = () => (track.firstElementChild?.offsetWidth || 300) + 5;
  const sync = () => {
    const media = track.querySelector('.media');
    if (media) rail.style.setProperty('--rail-arrow-top', `${media.offsetTop + media.offsetHeight / 2}px`);
    prev.disabled = track.scrollLeft < 4;
    next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
  };
  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
});

// ---------- "Ajouter l'ensemble" : toutes les pieces d'un coup (delegation) ----------
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-add-set]');
  if (!btn || btn.disabled) return;
  const label = btn.querySelector('[data-quick-label]');
  const initial = label.innerHTML;
  const reload = btn.hasAttribute('data-add-set-reload');
  btn.disabled = true;
  if (!reload) window.charmsCart?.open();
  try {
    const inCart = new Set((await (await fetch(root + 'cart.js')).json()).items.map((i) => i.variant_id));
    const items = btn.dataset.addSet.split(',').filter((id) => id && !inCart.has(Number(id))).map((id) => ({ id: Number(id), quantity: 1 }));
    if (!items.length) {
      label.textContent = 'Déjà dans le panier';
      return;
    }
    await addToCart(items);
    label.textContent = 'Ajouté au panier';
    if (reload) location.reload();
  } catch {
    label.textContent = 'Ajout impossible, réessayez';
  } finally {
    setTimeout(() => { label.innerHTML = initial; btn.disabled = false; }, 2000);
  }
});

// ---------- Mega-menu : un clic sur l'intitule (Colliers, Bracelets...) ouvre toujours "Tout voir" ----------
document.querySelectorAll('.nav__item.has-mega > .header__link').forEach((link) => {
  link.addEventListener('click', (e) => {
    const all = link.parentElement.querySelector('.mega__all');
    const href = link.getAttribute('href');
    const target = href && href !== '#' ? link.href : all?.href;
    if (!target) return;
    e.preventDefault();
    window.location.assign(target);
  });
});

// ---------- Mega-menu : se ferme des que la souris s'eloigne vers le bas, hors des liens et de la photo ----------
document.querySelectorAll('.nav__item.has-mega').forEach((item) => {
  const mega = item.querySelector('.mega');
  const cols = mega.querySelector('.mega__cols');
  const feature = mega.querySelector('.mega__feature');
  let last = null;
  mega.addEventListener('mousemove', (e) => {
    const dx = last ? e.clientX - last.x : 0;
    const dy = last ? e.clientY - last.y : 0;
    last = { x: e.clientX, y: e.clientY };
    // Vers la photo (a droite ou en diagonale) : on laisse ouvert ; tout droit vers le bas sous les liens : on ferme.
    if (dy <= 0 || dy < Math.abs(dx) * 1.5 || feature?.contains(e.target)) return;
    if (e.clientY > cols.getBoundingClientRect().bottom - 16) item.classList.add('is-dismissed');
  });
  item.addEventListener('mouseenter', () => { last = null; });
  item.addEventListener('mouseleave', () => item.classList.remove('is-dismissed'));
});
